/**
 * Report Service
 *
 * API client for report endpoints.
 */

import { fetchApi } from '@/shared/services';
import type {
  ReportParams,
  SpendingOverTimeResponse,
  IncomeVsExpenseResponse,
  CategoryDrillDownResponse,
  NetWorthTrendResponse,
  BudgetVsActualResponse,
} from '@/shared/types';

export const reportService = {
  getSpendingOverTime: (params: ReportParams) =>
    fetchApi<SpendingOverTimeResponse>('/reports/spending-over-time', {
      params: { ...params },
    }),

  getIncomeVsExpense: (params: ReportParams) =>
    fetchApi<IncomeVsExpenseResponse>('/reports/income-vs-expense', {
      params: { ...params },
    }),

  getCategoryDrilldown: (params: ReportParams) =>
    fetchApi<CategoryDrillDownResponse>('/reports/category-drilldown', {
      params: { ...params },
    }),

  getNetWorthTrend: (params: Omit<ReportParams, 'compare_start' | 'compare_end'>) =>
    fetchApi<NetWorthTrendResponse>('/reports/net-worth-trend', {
      params: { ...params },
    }),

  getBudgetVsActual: (params: ReportParams) =>
    fetchApi<BudgetVsActualResponse>('/reports/budget-vs-actual', {
      params: { ...params },
    }),
};
